<template>
  <VanDialog
    v-model:show="store.showScoreSettingModal"
    class="p-3 max-h-[80%] overflow-auto text-my-gray text-sm"
  >
    <div class="mb-4">
      <h2 class="text-lg">{{ t(`game.values.title`) }}</h2>
    </div>

    <template v-if="store.scoreList.length === 0">
      {{ t(`game.values.empty`) }}
    </template>
    <template v-else>
      <!-- 角色数值管理 -->
      <template
        v-for="(item, idx) in [...store.form.characterzz, store.form.player]"
      >
        <div
          v-if="
            store.scoreList.filter((v) => v.characterId === item.id).length > 0
          "
          :key="item.id"
          class="flex gap-2.5 mt-2.5 bg-neutral p-2.5"
        >
          <!-- left -->
          <div class="w-[62px]">
            <BaseImg
              :media="store.characterIdMap[item.id!].avatarMedia"
              class="rounded-sm"
              ratio="3/4"
            />
            <p class="line-clamp-1 text-center mt-1">
              {{ store.characterIdMap[item.id!].name }}
            </p>
          </div>
          <!-- right -->
          <div class="flex-1">
            <ul>
              <template v-for="score in store.scoreList">
                <li v-if="score.characterId === item.id" :key="score.id">
                  <div class="flex justify-between">
                    <div>
                      <p class="text-white">{{ score.name }}</p>
                      <p>
                        {{
                          valuesMap[score.id!] > 0
                            ? `+${valuesMap[score.id!]}`
                            : valuesMap[score.id!]
                        }}
                      </p>
                    </div>
                    <div class="flex gap-1">
                      <button
                        class="btn btn-primary btn-xs"
                        @click="clickSelectValues(score)"
                      >
                        <i
                          class="iconify mingcute--edit-3-line text-xs font-light"
                        />
                      </button>
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </template>

      <!-- 其他数值 -->
      <ul class="mt-2.5">
        <template v-for="score in store.scoreList">
          <li
            v-if="!score.characterId"
            :key="score.id"
            class="flex justify-between bg-my-dark p-2.5 mb-2.5"
          >
            <div>
              <p class="text-white">{{ score.name }}</p>
              <p>
                {{
                  valuesMap[score.id!] > 0
                    ? `+${valuesMap[score.id!]}`
                    : valuesMap[score.id!]
                }}
              </p>
            </div>
            <div class="flex gap-1">
              <button
                class="btn btn-primary btn-xs"
                @click="clickSelectValues(score)"
              >
                <i class="iconify mingcute--edit-3-line text-xs font-light" />
              </button>
            </div>
          </li>
        </template>
      </ul>
    </template>

    <template #footer>
      <div class="flex justify-center py-4">
        <button class="btn btn-primary btn-sm mr-2" @click="clickConfirm">
          {{ t("Buttons.confirm") }}
        </button>

        <button class="btn btn-sm" @click="store.showScoreSettingModal = false">
          {{ t(`story.g.cancel`) }}
        </button>
      </div>
    </template>
  </VanDialog>

  <ModalScoreSlider @update:score="clickScoreConfirm" />
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";
import { showFailToast } from "vant";
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const store = useGalGameEditor();
const { t } = useI18n();

const valuesMap = ref<Record<number, number>>({});

watch(
  () => store.showScoreSettingModal,
  (show) => {
    if (show) {
      const { score } = store.activeDialogOption;
      let _valuesMap: Record<number, number> = {};
      if (score && typeof score === "string") {
        const scoreArr = score.split("&&");
        for (const item of scoreArr) {
          const [key, value] = item.split("=");
          const ids = key.split("_");
          if (ids.length !== 3) continue;
          _valuesMap[Number(ids[2])] = Number(value);
        }
      }
      for (const score of store.scoreList) {
        valuesMap.value[score.id!] = _valuesMap[score.id!] || 0;
      }
    }
  }
);

function clickConfirm() {
  let _score = "";
  Object.entries(valuesMap.value).forEach(([valueId, score]) => {
    if (score === 0) return;
    let { characterId } =
      store.scoreList.find((v) => v.id === Number(valueId)) || {};
    if (!characterId) characterId = 0;
    let text = `_${characterId}_${valueId}=${score}`;
    _score += _score ? `&&${text}` : text;
  });
  store.activeDialogOption.score = _score;
  store.saveDialogOption();
  store.showScoreSettingModal = false;
}

let activeId = 0;
const clickSelectValues = (score: GalGameScore) => {
  let { characterId, id } = score;
  if (!characterId) characterId = 0;
  activeId = id!;
  store.modalScore = valuesMap.value[id!] || 0;
  store.showScoreSliderModal = true;
};

const clickScoreConfirm = () => {
  valuesMap.value[activeId] = store.modalScore;
};
</script>
